export default {
	install(Vue, { router, appTitle = null, separator = '-' }) {
		// Inject title in HTML document
		router.beforeEach((to, from, next) => {
			const routes = to.matched.slice().reverse()

			let { title } = (routes.find(record => record.meta && record.meta.title) || {}).meta || {}

			if (title && typeof title === 'function') {
				title = title(to.params, to.query)
			}

			if (title) {
				document.title = appTitle ? `${appTitle} ${separator} ${title}` : title
			} else if (appTitle) {
				document.title = appTitle
			}

			return next()
		})
	},
}
